export default () => ({
  icon: {
    alignSelf: 'flex-start',
    marginTop: 0,
    '@media (min-width: 766px)': {
      marginTop: 14,
    },
  },
});
